<template>
  <page-container>
    <heading size="gigantic">Email verification</heading>

    <b-message
      v-if="isLoading"
      type="is-primary"
      title="Verif"
      :closable="false"
    >
      We are verifying your email. <br />
      This will take a few seconds...
    </b-message>

    <b-message
      v-if="!isLoading && success"
      type="is-success"
      title="Verification successful"
      :closable="false"
    >
      Your email has been verified.<br />
      <b-button class="mt3" tag="router-link" to="/resources" icon-left="link"
        >Back to resources</b-button
      >
    </b-message>

    <b-message
      v-else-if="!isLoading && !success"
      type="is-danger"
      title="Email could not be verified"
      :closable="false"
    >
      There was an error while verifying your email.<br />
      You can request a new verification email and try again.<br />
      <b-button
        v-if="!resendSuccess"
        class="mt3"
        @click="resendVerifyEmail()"
        :loading="resendingVerifyMail"
        >Send a new one</b-button
      >
      <b-button v-else class="mt3" type="is-success"
        >New verification email sent</b-button
      >
    </b-message>

    <!-- <b-button v-if="isLoading" :loading="isLoading">Verifying email</b-button> -->
  </page-container>
</template>

<script>
export default {
  data: () => ({
    isLoading: true,
    success: false,
    resendSuccess: false,
    resendingVerifyMail: false
  }),

  methods: {
    async resendVerifyEmail() {
      this.resendingVerifyMail = true;
      const res = await this.$store.dispatch("resendVerifyEmail");
      this.resendingVerifyMail = false;
      this.resendSuccess = res;
    }
  },

  async created() {
    if (this.$route.query.verifyUrl) {
      const signedURL = new URL(this.$route.query.verifyUrl);
      const expires = signedURL.searchParams.get("expires");
      const signature = signedURL.searchParams.get("signature");
      this.$router.replace({ query: {} });
      const res = await this.$store.dispatch("verifyEmail", {
        expires,
        signature
      });
      this.$auth.fetch({
        success: () => {
          this.success = res;
          this.isLoading = false;
        },
        error: () => {
          window.location.href = this.$env.VUE_APP_URL;
        }
      });
    } else {
      this.$router.push({ name: "resources" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
